/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_uc_wt_faq4_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Most kitchen scales only display whole grams or increments of 1-5 grams, so they round the exact result. This converter shows more decimal places by default since it isn't limited by a physical display — for cooking, rounding to the nearest gram is normally accurate enough.`)
};

const es_uc_wt_faq4_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`La mayoría de las básculas de cocina solo muestran gramos completos o incrementos de 1-5 gramos, así que redondean el resultado exacto. Este conversor muestra más decimales por defecto ya que no está limitado por una pantalla física — para cocinar, redondear al gramo más cercano normalmente es lo suficientemente preciso.`)
};

const de_uc_wt_faq4_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Die meisten Küchenwaagen zeigen nur ganze Gramm oder Schritte von 1-5 Gramm an und runden das exakte Ergebnis daher. Dieser Umrechner zeigt standardmäßig mehr Nachkommastellen, da er nicht durch ein physisches Display begrenzt ist — zum Kochen reicht eine Rundung auf das nächste Gramm normalerweise völlig aus.`)
};

const nl_uc_wt_faq4_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`De meeste keukenweegschalen geven alleen hele gram of stapeling van 1-5 gram weer, dus zij ronden het exacte resultaat af. Deze convertor toont meer decimalen standaard omdat deze niet beperkt is door een fysiek display — voor koken is afronding tot de dichtstbijzijnde gram normaal nauwkeurig genoeg.`)
};

const fr_uc_wt_faq4_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`La plupart des balances de cuisine n'affichent que des grammes entiers ou des incréments de 1-5 grammes, donc elles arrondissent le résultat exact. Ce convertisseur affiche plus de décimales par défaut puisqu'il n'est pas limité par un affichage physique — pour la cuisine, l'arrondi au gramme le plus proche est normalement assez précis.`)
};

const it_uc_wt_faq4_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`La maggior parte delle bilance da cucina visualizza solo grammi interi o incrementi di 1-5 grammi, quindi arrotondano il risultato esatto. Questo convertitore mostra più cifre decimali per impostazione predefinita poiché non è limitato da un display fisico — per la cucina, l'arrotondamento al grammo più vicino è normalmente abbastanza accurato.`)
};

const pt_br2_uc_wt_faq4_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`A maioria das balanças de cozinha exibe apenas gramas inteiros ou incrementos de 1-5 gramas, então arredondam o resultado exato. Este conversor mostra mais casas decimais por padrão já que não é limitado por um visor físico — para cozinhar, arredondar para o grama mais próximo é normalmente preciso o suficiente.`)
};

const pt_uc_wt_faq4_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`A maioria das balanças de cozinha apenas apresentam gramas inteiros ou incrementos de 1-5 gramas, portanto arredondam o resultado exacto. Este conversor mostra mais casas decimais por padrão já que não está limitado por um ecrã físico — para cozinhar, arredondar para o grama mais próximo é normalmente preciso o suficiente.`)
};

const ja_uc_wt_faq4_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ほとんどの台所スケールは1グラムまたは1〜5グラムの増分のみを表示するため、正確な結果を丸めます。このコンバーターは物理的なディスプレイで制限されていないため、デフォルトでより多くの小数位を表示します。調理の場合、最も近いグラムに丸めることは通常、正確さに十分です。`)
};

const zh_uc_wt_faq4_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`[pending translation B]`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const uc_wt_faq4_a = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.uc_wt_faq4_a(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("uc_wt_faq4_a", locale)
	if (locale === "en") return en_uc_wt_faq4_a(inputs)
	if (locale === "es") return es_uc_wt_faq4_a(inputs)
	if (locale === "de") return de_uc_wt_faq4_a(inputs)
	if (locale === "nl") return nl_uc_wt_faq4_a(inputs)
	if (locale === "fr") return fr_uc_wt_faq4_a(inputs)
	if (locale === "it") return it_uc_wt_faq4_a(inputs)
	if (locale === "pt-BR") return pt_br2_uc_wt_faq4_a(inputs)
	if (locale === "pt") return pt_uc_wt_faq4_a(inputs)
	if (locale === "ja") return ja_uc_wt_faq4_a(inputs)
	return zh_uc_wt_faq4_a(inputs)
};